import * as config from './uiConfig';
import { Script } from 'src/replicant/conversation/conservation.ruleset';
import { Widen } from 'src/replicant/utils/types';
import StateObserver from 'src/StateObserver';
import * as Conversation from 'src/replicant/conversation';
import PopupSpeechBubbleBase, {
  SpeechBubbleCloseHandler,
} from './PopupSpeechBubbleBase';
import { View } from '@play-co/timestep-core/ui';
import { GCInstant as platform } from 'src/lib/gcinstant';
import {
  getPlayerIdFromConversation,
  getScriptText,
} from 'src/game/conversation/conversation.utils';

export default class PopupConversationScript extends PopupSpeechBubbleBase {
  constructor(opts: {
    superview: View;
    close: SpeechBubbleCloseHandler<void>;
  }) {
    super({ ...opts, $subFeature: 'script', closeAfterSkip: true });
  }

  public init({ id, move_to }: Pick<Widen<Script>, 'id' | 'move_to'>) {
    const { user, ui } = StateObserver.getState();

    super.init({
      id,
      move_to,
      message: getScriptText(
        user,
        id,
        ui.locale,
        getPlayerIdFromConversation(id) !== platform.playerID,
      ),
    });
  }
}
